import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { MpsUserService } from '@mps/services/mps-user.service';
import { DEFAULT_PROFILE, Profile, PROFILES, ProfileType } from '../models/profile.model';
import { ProfileService } from '../services/profile.service';

@Component({
  selector: 'app-profile-selector',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatMenuModule, MatIconModule],
  template: `
    <button
      class="select-profile-button"
      [matMenuTriggerFor]="profileMenu"
      [title]="'Profil actuel: ' + currentProfileData.label"
    >
      <span style="margin-right: 4px;">
        {{ currentProfileData.label }}
      </span>
      <mat-icon fontSet="material-icons-outlined">
        {{ currentProfileData.icon }}
      </mat-icon>
    </button>

    <div style="margin-right: 14px;"></div>

    <mat-menu #profileMenu="matMenu">
      <button
        *ngFor="let profile of availableProfiles"
        mat-menu-item
        [class.active]="currentProfile === profile.id"
        (click)="selectProfile(profile.id)"
      >
        <mat-icon
          fontSet="material-icons-outlined"
          [style.color]="profile.color"
          [style.opacity]="currentProfile === profile.id ? '1' : '0.6'"
        >
          {{ currentProfile === profile.id ? 'check_circle' : profile.icon }}
        </mat-icon>
        <span>
          {{ profile.label }}
        </span>
      </button>
    </mat-menu>
  `,
  styles: [
    `
      .select-profile-button {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
        color: var(--total-clr-typo-red);

        background: transparent;
        border: none;
        cursor: pointer;
      }
      button[mat-menu-item].active {
        background-color: rgba(0, 0, 0, 0.04);
        font-weight: 500;
      }
    `,
  ],
})
export class ProfileSelectorComponent implements OnInit {
  currentProfile: ProfileType = DEFAULT_PROFILE;
  currentProfileData: Profile = PROFILES[0];
  availableProfiles: Profile[] = [];

  constructor(private profileService: ProfileService) {}
  userService = inject(MpsUserService);
  router = inject(Router);

  ngOnInit(): void {
    const savedProfile = this.profileService.loadFromStorage();
    const user = this.userService.getUser();
    let currentProfile = savedProfile;

    //check
    if (savedProfile === 'cd' && !user?.see_cd) currentProfile = 'unkown';
    if (savedProfile === 'hpg' && !user?.see_hpg) currentProfile = 'unkown';
    if (savedProfile === 'n17' && !user?.see_hpg) currentProfile = 'unkown';

    if (user?.see_hpg) this.availableProfiles.push(PROFILES[0]);
    if (user?.see_cd) this.availableProfiles.push(PROFILES[1]);
    if (user?.see_n17) this.availableProfiles.push(PROFILES[2]);

    if (currentProfile === 'unkown' && this.availableProfiles.length > 0) {
      currentProfile = this.availableProfiles[0].id;
    }
    this.profileService.setCurrentProfile(currentProfile);

    this.currentProfile = this.profileService.getCurrentProfile();
    this.currentProfileData = this.profileService.getCurrentProfileData();
  }

  selectProfile(profile: ProfileType): void {
    if (profile !== this.currentProfile) {
      this.profileService.setCurrentProfile(profile);
      this.router.navigate(['/hpc/home']).then(() => {
        window.location.reload();
      });
    }
  }
}
